export default __webpack_public_path__ + "static/media/logo.d61db8d4.png";